import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, MutationIntentProjectConfigDeleteArgs } from "types/generated";

export const INTENT_PROJECT_CONFIG_DELETE: TypedDocumentNode<
  { intentProjectConfigDelete: IntentProject },
  MutationIntentProjectConfigDeleteArgs
> = gql`
  mutation IntentProjectConfigDelete($project: ID!, $config: ID!) {
    intentProjectConfigDelete(project: $project, config: $config) {
      id
      type
    }
  }
`;
